export default __webpack_public_path__ + "static/media/dashboard_restmon.01060e1f.png";